<template>
    <div
        class="
            pb-2
            mb-4
            border-b border-b-gray-300
            text-lg
            flex
            justify-between
        "
    >
        <div class="flex items-center gap-1">
            <ion-icon
                name="film-outline"
                v-if="videoGroup.id == -1"
                style="font-size: 24px"
            ></ion-icon>
            <ion-icon
                name="film-outline"
                v-else
                style="color: #048abf; font-size: 24px"
            ></ion-icon>
            {{ videoGroup.name }}
            <span class="font-bold text-[#999999]">({{ props.count }})</span>
        </div>

        <div class="flex gap-4 items-center">
            <template v-if="count > 0">
                <template v-if="bulkSelection.isMode(groupKey)">
                    <button
                        type="button"
                        class="
                            text-sm
                            py-1.5
                            px-3
                            rounded-lg
                            bg-red-500
                            text-white
                            hover:bg-red-600
                            disabled:opacity-50
                            flex
                            items-center
                            gap-1
                        "
                        :disabled="bulkSelection.count(groupKey) === 0"
                        @click="confirmOpen = true"
                    >
                        <ion-icon name="trash-outline"></ion-icon>
                        Delete ({{ bulkSelection.count(groupKey) }})
                    </button>
                    <button
                        type="button"
                        class="
                            text-sm
                            py-1.5
                            px-3
                            rounded-lg
                            border border-gray-300
                            hover:bg-gray-100
                        "
                        @click="bulkSelection.setMode(groupKey, false)"
                    >
                        Cancel
                    </button>
                </template>
            </template>
            <button
                type="button"
                class="
                    p-2
                    hover:bg-gray-100
                    rounded
                    flex
                    items-center
                    justify-center
                "
                @click="toggleOpen"
            >
                <ion-icon
                    v-if="!state.isOpen"
                    name="chevron-down-outline"
                ></ion-icon>
                <ion-icon v-else name="chevron-up-outline"></ion-icon>
            </button>
            <context-menu
                class=""
                v-if="videoGroup.id != -1 && videoGroup.id != -2"
            >
                <li>
                    <VideoGroupSetting :video-group="videoGroup" />
                </li>

                <li v-if="canCreateVideo">
                    <Modal title="Upload video">
                        <div
                            class="
                                py-2
                                px-3
                                my-1
                                hover:bg-gray-300
                                rounded-lg
                                cursor-pointer
                            "
                        >
                            Upload video
                        </div>

                        <template #body="{ close }">
                            <hr class="gray-500 my-4" />

                            <div
                                v-if="state.video.isUploading"
                                class="
                                    flex flex-col
                                    items-center
                                    justify-center
                                "
                            >
                                <LoadingCircle></LoadingCircle>
                                <div class="mt-3 text-[16px] text-bold">
                                    {{ state.video.progress }}
                                </div>
                            </div>
                            <form
                                method="post"
                                @submit.prevent="uploadVideo()"
                                v-else
                            >
                                <div class="my-2">
                                    <label
                                        for="title"
                                        class="block font-semibold my-2 text-sm"
                                    >
                                        Title
                                    </label>
                                    <new-input
                                        required
                                        maxlength="128"
                                        label="Title"
                                        name="title"
                                        placeholder="Enter video title"
                                        v-model="state.video.title"
                                    ></new-input>
                                </div>

                                <div class="my-2">
                                    <label
                                        for="description"
                                        class="block font-semibold my-2 text-sm"
                                    >
                                        Description
                                    </label>
                                    <new-input
                                        maxlength="128"
                                        label="Description"
                                        name="description"
                                        placeholder="Enter video description"
                                        v-model="state.video.description"
                                    ></new-input>
                                </div>

                                <video-input
                                    @change="handleVideoInput"
                                ></video-input>

                                <div
                                    class="
                                        mt-8
                                        flex
                                        items-center
                                        gap-4
                                        justify-end
                                    "
                                >
                                    <app-button
                                        @click="close"
                                        class="
                                            border border-accent
                                            text-accent
                                            !bg-white
                                        "
                                    >
                                        Cancel
                                    </app-button>
                                    <app-button
                                        :disabled="state.file === null"
                                        type="submit"
                                        class="!bg-primary text-white"
                                        >Submit</app-button
                                    >
                                </div>
                            </form>
                        </template>
                    </Modal>
                </li>

                <li @click="bulkSelection.setMode(groupKey, true)" v-if="count > 0">
<div
                            class="
                                py-1
                                pl-3
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                                text-red-500
                            "
                        >
                            <button
                                type="button"
                                class="
                                    flex-grow-1 flex-shrink-0
                                    font-slab
                                    mt-1
                                    pb-1
                                "
                            >
                                Bulk Delete
                            </button>
                        </div>
                </li>

                <li @click="$refs.deleteForm.submit()">
                    <form
                        action="/video/delete-group"
                        method="post"
                        ref="deleteForm"
                    >
                        <input
                            type="hidden"
                            name="_token"
                            :value="$root.csrfToken"
                        />
                        <input type="hidden" name="id" :value="videoGroup.id" />
                        <div
                            class="
                                py-1
                                pl-3
                                pr-8
                                flex flex-row
                                items-center
                                text-left
                                gap-2
                                cursor-pointer
                                hover:bg-gray-300
                                rounded-lg
                                text-red-500
                            "
                        >
                            <button
                                type="submit"
                                class="
                                    flex-grow-1 flex-shrink-0
                                    font-slab
                                    mt-1
                                    pb-1
                                "
                            >
                                Delete
                            </button>
                        </div>
                    </form>
                </li>
            </context-menu>
        </div>
    </div>
    <div v-show="state.isOpen">
        <slot></slot>
    </div>

    <MiniModalCustom
        :is-open="confirmOpen"
        title="Delete Videos"
        @close="confirmOpen = false"
        z-index="1003"
    >
        <p class="text-sm text-gray-700">
            Are you sure you want to delete
            <span class="font-semibold">{{
                bulkSelection.count(groupKey)
            }}</span>
            selected video<span v-if="bulkSelection.count(groupKey) !== 1"
                >s</span
            >? This action cannot be undone.
        </p>
        <div class="mt-6 flex justify-end gap-3">
            <button
                type="button"
                class="
                    border border-gray-300
                    rounded-lg
                    py-2
                    px-4
                    hover:bg-gray-100
                "
                :disabled="deleting"
                @click="confirmOpen = false"
            >
                Cancel
            </button>
            <button
                type="button"
                class="
                    bg-red-500
                    text-white
                    rounded-lg
                    py-2
                    px-4
                    hover:bg-red-600
                    disabled:opacity-60
                "
                :disabled="deleting"
                @click="bulkDelete"
            >
                {{ deleting ? "Deleting…" : "Delete" }}
            </button>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import ModalCustom from "./ModalCustom";
import TagForm from "./TagForm";
import { createPopper } from "@popperjs/core";
import Modal from "./Modal";
import VideoPlayer from "./VideoPlayer";
import AppInput from "./AppInput";
import AppButton from "./AppButton";
import MiniModalCustom from "./MiniModalCustom";
import bulkSelection from "../stores/bulkSelection";
import { ref, onMounted, watch, nextTick, reactive, computed } from "vue";
import draggable from "vuedraggable";

const props = defineProps({
    videoGroup: {
        type: Object,
        required: true,
    },
    canCreateVideo: {
        type: Boolean,
    },
    count: {
        type: Number,
        default: 0,
    },
});

const state = reactive({
    video: {
        title: "",
        description: "",
        file: null,
        thumbnail: null,
        progress: "Please wait, uploading 0%",
        isUploading: false,
        uploadId: null,
        parts: [],
    },
    isOpen: false,
});

const teamIdFromUrl = new URLSearchParams(window.location.search).get("teamId");
const popperInstance = ref(null);

// Bulk-selection / bulk-delete
const groupKey = computed(() => `video-${props.videoGroup.id}`);
const confirmOpen = ref(false);
const deleting = ref(false);

async function bulkDelete() {
    const ids = bulkSelection.selected(groupKey.value);
    if (ids.length === 0) {
        return;
    }
    deleting.value = true;
    try {
        await axios.post("/video/bulk-delete", { ids });
        window.location.reload();
    } catch (e) {
        console.error(e);
        deleting.value = false;
        confirmOpen.value = false;
    }
}

function handleVideoInput(metadata) {
    state.video.file = metadata.file;
    state.video.thumbnail = metadata.thumbnail;
}

async function uploadVideo() {
    try {
        state.video.isUploading = true;
        let dir = teamIdFromUrl;

        if (!dir) {
            dir = props.videoGroup.user_id;
        }
        const key = state.video.file.name;
        const createResponse = await axios.post(
            "/upload/create-multipart-upload",
            { key, dir }
        );
        state.video.uploadId = createResponse.data.UploadId;

        await uploadParts(createResponse.data.Key);
        const resp = await completeUpload(createResponse.data.Key);
        await createVideoEntry(resp.data.url);
    } catch (e) {
        console.error(e);
    }

    state.video.isUploading = false;
    state.video.parts = [];
}

async function uploadParts(key) {
    const fileSize = state.video.file.size;
    let start = 0;
    let partNumber = 1;
    const partSize = 50 * 1024 * 1024; // 100MB part size
    const partLength = Math.round(state.video.file.size / partSize);
    let partIndex = 0;

    while (start < fileSize) {
        const end = Math.min(start + partSize, fileSize);
        const filePart = state.video.file.slice(start, end);

        // Get presigned URL from the server
        const presignedResponse = await axios.post(
            "/upload/generate-presigned-url",
            {
                key: key,
                uploadId: state.video.uploadId,
                partNumber,
            }
        );

        let presignedUrl = presignedResponse.data.url;
        presignedUrl = presignedUrl.replace(
            "http://host.docker.internal:4566",
            "http://localhost:4566"
        );

        // Upload the file part to S3
        const uploadResponse = await axios.put(presignedUrl, filePart, {
            headers: { "Content-Type": "application/octet-stream" },
            transformRequest: [
                (data, headers) => {
                    delete headers.common;
                    delete headers.post;
                    delete headers.put;
                    return data;
                },
            ],
        });

        state.video.parts.push({
            PartNumber: partNumber,
            ETag: uploadResponse.headers.etag,
        });

        start = end;
        partNumber++;
        partIndex++;
        const progress = Math.round((partIndex / partLength) * 100);
        if (progress < 99) {
            state.video.progress = `Please wait, uploading ${progress}%`;
        } else {
            state.video.progress = "Processing...";
        }
    }
}

async function completeUpload(key) {
    return axios.post("/upload/complete-multipart-upload", {
        key: key,
        uploadId: state.video.uploadId,
        parts: state.video.parts,
    });
}

async function createVideoEntry(url) {
    let formData = new FormData();
    formData.append("url", url);
    formData.append("thumbnail", state.video.thumbnail);
    formData.append("size", state.video.file.size);
    formData.append("title", state.video.title);
    formData.append("description", state.video.description);
    if (teamIdFromUrl) {
        formData.append("team_id", teamIdFromUrl);
    }
    formData.append("video_group_id", props.videoGroup.id);

    console.log({ formData });

    try {
        await axios.post("/video/store", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        let url = new URL(window.location.href);
        window.location.href = url.href;
    } catch (e) {
        console.error(e);
    }
}

function getStorageKey() {
    let storageKey = "my_videogroups_open";
    if (teamIdFromUrl) {
        storageKey = "team_" + teamIdFromUrl + "_videogroups_open";
    }
    console.log({ storageKey });
    return storageKey;
}

function toggleOpen() {
    state.isOpen = !state.isOpen;

    let currentOpenIndexes = [];
    try {
        currentOpenIndexes = JSON.parse(
            sessionStorage.getItem(getStorageKey())
        );
    } catch (e) {}
    if (!currentOpenIndexes) {
        currentOpenIndexes = [];
    }

    if (state.isOpen) {
        if (!currentOpenIndexes.includes(props.videoGroup.id)) {
            currentOpenIndexes.push(props.videoGroup.id);
            sessionStorage.setItem(
                getStorageKey(),
                JSON.stringify(currentOpenIndexes)
            );
        }
    } else {
        currentOpenIndexes.splice(
            currentOpenIndexes.indexOf(props.videoGroup.id),
            1
        );
        sessionStorage.setItem(
            getStorageKey(),
            JSON.stringify(currentOpenIndexes)
        );
    }
}

function getOpenState() {
    let currentOpenIndexes = [];
    try {
        currentOpenIndexes = JSON.parse(
            sessionStorage.getItem(getStorageKey())
        );
    } catch (e) {}
    if (!currentOpenIndexes) {
        return;
    }
    state.isOpen = currentOpenIndexes.includes(props.videoGroup.id);
}

onMounted(() => {
    getOpenState();
});
</script>

<style scoped></style>
